import RevenueSplit from 'components/rtoken-setup/token/RevenueSplit'
import SectionWrapper from '@/components/section-navigation/section-wrapper'
import BackingManager from '@/views/yield-dtf/deploy/components/BackingManager'
import OtherSetup from '@/views/yield-dtf/deploy/components/OtherSetup'
import Intro from './Intro'
import ProposalBasketSetup from './ProposalBasketSetup'
import RolesProposal from './RolesProposal'
import UnregisterProposal from './UnregisterProposal'
import RegisterProposal from './RegisterProposal'
import TraderImplementationProposal from './TraderImplementationProposal'
import ContractUpgrades from './ContractUpgrades'
import ProposalGovernanceParams from './forms/ProposalGovernanceParams'
import SpellUpgrade from './SpellUpgrade'

const sections = [
  Intro,
  BackingManager,
  OtherSetup,
  TraderImplementationProposal,
  RolesProposal,
  RevenueSplit,
  UnregisterProposal,
  RegisterProposal,
  ContractUpgrades,
  SpellUpgrade,
  ProposalGovernanceParams,
]

const ProposalForm = () => (
  <div className="mb-4">
    {sections.map((Component, index) => (
      <SectionWrapper
        key={index}
        threshold={index === 3 ? 0.3 : 0.5}
        navigationIndex={index}
        className="mb-4"
      >
        <Component />
      </SectionWrapper>
    ))}
    <ProposalBasketSetup startIndex={sections.length} />
  </div>
)

export default ProposalForm
